<template>
    <div class="row row-compress row-compress-indent">
        <div class="column small-12 medium-6">
            <div class="form-group" v-bind:class="{ 'has-error': validationErrors.has('starts_at') }">
                <label>
                    {{ trans('Starts at') }}
                    <date-pick
                        v-model="startsAt"
                        v-bind:input-attributes="{'class': 'input__field input__field--date', 'placeholder': trans('Pick a date and time')}"
                        v-bind:pickTime="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        v-bind:nextMonthCaption="datePickLabels.nextMonthCaption"
                        v-bind:prevMonthCaption="datePickLabels.prevMonthCaption"
                        v-bind:setTimeCaption="datePickLabels.setTimeCaption"
                        v-bind:weekdays="datePickLabels.weekdays"
                        v-bind:months="datePickLabels.months"
                    ></date-pick>
                </label>
                <input type="hidden" name="starts_at" v-bind:value="startsAtUtc">
            </div>
            <div v-if="validationErrors.has('starts_at')" class="form-help">{{ validationErrors.first('starts_at') }}</div>
        </div>
        <div class="column small-12 medium-6">
            <div class="form-group" v-bind:class="{ 'has-error': validationErrors.has('ends_at') }">
                <label>
                    {{ trans('Ends at') }}
                    <date-pick
                        v-model="endsAt"
                        v-bind:input-attributes="{'class': 'input__field input__field--date', 'placeholder': trans('Pick a date and time')}"
                        v-bind:pickTime="true"
                        format="YYYY-MM-DD HH:mm:ss"
                        v-bind:nextMonthCaption="datePickLabels.nextMonthCaption"
                        v-bind:prevMonthCaption="datePickLabels.prevMonthCaption"
                        v-bind:setTimeCaption="datePickLabels.setTimeCaption"
                        v-bind:weekdays="datePickLabels.weekdays"
                        v-bind:months="datePickLabels.months"
                    ></date-pick>
                </label>
                <input type="hidden" name="ends_at" v-bind:value="endsAtUtc">
            </div>
            <div v-if="validationErrors.has('ends_at')" class="form-help">{{ validationErrors.first('ends_at') }}</div>
        </div>
    </div>
</template>
<script>
import DatePick from 'vue-date-pick';
import DatePickLocalizationMixin from '../fields/DatePickLocalizationMixin.vue';
import Errors from '../../errors.js';
import { EventBus } from '../../event-bus';

export default {
    components: {
        DatePick,
    },
    mixins: [
        DatePickLocalizationMixin,
    ],
    props: {
        startsAtValue: {
            type: String,
            default: '',
        },
        endsAtValue: {
            type: String,
            default: '',
        },
        errors: {
            type: [Array, Object],
        },
    },
    data() {
        return {
            startsAt: this.startsAtValue ? this.utcToLocal(this.startsAtValue) : '',
            endsAt: this.endsAtValue ? this.utcToLocal(this.endsAtValue) : '',
            startsAtUtc: this.startsAtValue,
            endsAtUtc: this.endsAtValue,
            validationErrors: new Errors(this.errors || {}),
        };
    },
    watch: {
        startsAt(value) {
            this.startsAtUtc = value ? this.localToUtc(value) : '';
            EventBus.$emit('form:element:changed', 'starts_at', this.startsAtUtc);
        },
        endsAt(value) {
            this.endsAtUtc = value ? this.localToUtc(value) : '';
            EventBus.$emit('form:element:changed', 'ends_at', this.endsAtUtc);
        },
    },
    mounted() {
        this.$nextTick(() => {
            EventBus.$emit('form:element:initialize', 'starts_at', this.startsAtUtc);
            EventBus.$emit('form:element:initialize', 'ends_at', this.endsAtUtc);
        });
    },
    methods: {
        parseAsUtc(str) {
            const [datePart, timePart] = str.split(' ');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);
            return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
        },
        parseAsLocal(str) {
            const [datePart, timePart] = str.split(' ');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);
            return new Date(year, month - 1, day, hour, minute, second);
        },
        formatLocal(date) {
            const pad = (n) => String(n).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        },
        formatUtc(date) {
            const pad = (n) => String(n).padStart(2, '0');
            return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
        },
        utcToLocal(utcStr) {
            return this.formatLocal(this.parseAsUtc(utcStr));
        },
        localToUtc(localStr) {
            return this.formatUtc(this.parseAsLocal(localStr));
        },
    },
}
</script>
